<template>
  <form @submit.prevent="handleSubmit">
    <modal-card title="Add Message" style="margin: 0 auto;" contains-dropdown>

      <b-field label="Message">
        <b-input v-model="form.message" placeholder="What you want to send?"></b-input>
      </b-field>

      <b-field label="Frequence">
        <b-select v-model="form.send_frequence" expanded>
          <option value="every_monday">Every monday</option>
          <option value="twice_monthly">Twice monthly</option>
          <option value="inactive_users">Inactive users</option>
        </b-select>
      </b-field>

      <div slot="foot">
        <button type="button" class="button" @click="$parent.close()">
          Close
        </button>

        <button
          class="button is-primary"
          :class="{ 'is-loading': form.processing }"
        >
          Add Message
        </button>
      </div>
    </modal-card>
  </form>
</template>

<script>

export default {

  props: {
    added: {
      type: Function,
      required: true
    }
  },

  data() {
    return {
      form: new window.Form({
        message: null,
        send_frequence: 'every_monday',
      })
    };
  },

  methods: {
    handleSubmit() {
      this.form.post("/admin/api/notifications/scheduled").then(this.whenAdded);
    },

    whenAdded() {
      this.added();

      this.$buefy.toast.open("New message has been added.");

      this.$parent.close();
    }
  }
};
</script>
